<template>
  <div class="alxq2">
    <div v-wechat-title="$route.meta.title"></div>

    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd bxz">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox"></div>
    <div class="alxqboxbox">
      <div class="alxqbox">
        <div class="text text1">2021 - 6 - 16</div>
        <div class="text text2">汽修行业怎么做？这篇告诉你门店爆满的秘密</div>
        <div class="text text3">
          一、汽修行业痛点
          <br />

         目前在我国的汽车市场上，家用汽车的保有量越来越充足了，很多都是一家两车、甚至三车。再加上目前汽修行业的修理厂和路边小修门店也越来越多，大学扩招、国家对专业技术人才的重视和引导、入行业的门槛低等一系列原因，造成竞争力越来越激烈。
          <br />

         虽然每个行业都存在其问题，但目前汽修行业存在5大痛点，最困扰现今的汽修老板们，这些问题如果不能解决，将会制约到门店的未来发展。

        </div>

                <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/qxhyzmz1.223e136.png"
            alt=""
          />
        </div>
        <div class="text text3">
         1、渠道有限，企业难生存
          <br />

       2、库存积压，规划捋不清
          <br />

        3、眼光长远，实操难布局
          <br />

       4、能力有限，团队难管理
          <br />
5、缺少监督，员工难掌控
          <br />

         如何解决这5大问题，找对方法即可快速破局。
          <br />

        从营销角度看，这5大问题其实侧面暴露了汽修店在引流难 截留难 资金回流难 裂变复购难这四大方面的问题。换句话说，这四个营销问题解决了，汽修门店也就从整个大行业中脱颖而出了。
          <br />

       但知易行难，到底要如何解决这些难题呢？有没有高效、可操作性，且已经被市场验证过的营销活动呢？
          <br />

       有的，具体往下看↓↓↓↓↓↓↓↓↓↓↓↓
          <br />

         二、具体活动及配套产品推荐
          <br />

        引流难 可用对汽修行业受众人群吸引力高的产品，如商务手表、车载音响、充电器。如活动期间进店即送车载音响，限量100个。
          <br />
截流难 让潜在客户持续看到自己的门店、自己的优势，才能最大的截流客户，从营销上，一定要让客户在自己的店铺实现从零到一的消费突破，才能把蛋糕从别人手中抢过来。同样需要使用礼品营销策略让客户心甘情愿实现新的突破。如新客户0元开卡，一元可享换购玻璃水活动，30天后仍可再次购买该活动。

          <br />
          营销策略让客户心甘情愿实现新的突破。如新客户0元开卡，一元可享换购玻璃水活动，30天后仍可再次购买该活动。
          <br />
          资金回流难和裂变复购难同样要求有了一定客户基础后，进一步争取客户的附加值，这里推荐一个多方满足难点、痛点，快速破局的方法。
          <br />
          这个破局方法即—— 储值 。
          <br />
         汽修门店可采取“充值2000得2000返2000送2000”的储值策略，当然根据各门店实力、人均消费、次均消费等各自设置活动数额，产品方面不止以下，千余产品支持各样数额活动。该方案可一站解决汽修门店这四大老大难的问题，尤其是在资金回流难的问题上。
          <br />
           步骤1：客户预存2000元，可得同等价值产品，支持组合：


        </div>
                        <div style="width: 100%">
          <img
            src="http://www.micreat.com/static/img/qxhyzmz2.45d2ac4.png"
            alt=""
          />
        </div>
                <div class="text text3">
       步骤2：引导客户下载米小礼软件，即可得同等数额的积分，米小礼上拥有的广泛用户量和产品基础，消费者可以在米小礼上消费积分获得礼品。自己的汽修门店也可以相应上架利润高的热卖产品，吸引劝说消费者使用米小礼并消费自己上架的套餐。此为“返”2000。
          <br />

       步骤3：最后的“送2000”需根据商家自身门店、优势资源、消费群体属性等定制，此步骤可联系文章下方可提供定制服务的市场部人员，不管您是汽修还是其他行业，均可提供定制方案为业绩助力。

        </div>
        <div class="gjcanwxwbqqbox">
          <div class="gjcanwxwbqqleft"></div>
          <div class="gjcanwxwbqqright">
            <div @click="shareToQQ()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg1"></div>
            <div @click="WeixinJSBridge()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg2"></div>
            <div  @click="shareToMicroblog()" class="gjcanwxwbqqrightimg gjcanwxwbqqrightimg3"></div>
          </div>
        </div>
        <div class="hengxian"></div>
        <div class="xgaltext">相关案例</div>
        <div class="xgalbox">
          <div @click="tiaozhuan(1)" class="xgalboxs xgalboxs1">
            <div class="xgalboxstext">饺子馆会员制简单有效促使精准回流</div>
          </div>
          <div @click="tiaozhuan(2)" class="xgalboxs xgalboxs2">
            <div class="xgalboxstext">健身俱乐部引流锁客经典案</div>
          </div>
          <div @click="tiaozhuan(3)" class="xgalboxs xgalboxs3">
            <div class="xgalboxstext">用2个步骤，一周新增628客户，营收91万！</div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import API from "@/service/common.service.js";

export default {
  data() {
    //

    return {
      active: 0,
      hsk:1,

    };
  },
  mounted() {},
  methods: {
    //分享到QQ好友(PC端可用)
    shareToQQ() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        // share_url: "http://www.micreat.com/#/"
        share_url: "http://www.micreat.com?projectId=1"

      };
      // var qqqq = "https://connect.qq.com/widget/shareqq/index.html?url=" +
      var qqqq = "https://api.pwmqr.com/qrcode/create/?url=" +

          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(qqqq, 'newwindow', 'height=400,width=400,top=200,left=600');

    },
    //分享到QQ空间(可用)
    WeixinJSBridge() {
      //此处分享链接内无法携带图片
      const share = {
        title: "米创集团",
        desc: "",
        share_url: "http://www.micreat.com?projectId=1"
      };
      var wwww = "https://api.pwmqr.com/qrcode/create/?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&desc=" +
          share.desc

        window.open(wwww, 'newwindow', 'height=400,width=400,top=200,left=600');
    },
    //分享到微博(可用)
    shareToMicroblog() {
      //自定义内容
      const share = {
        title: "米创集团",
        image_url: ["https://api.mxl.mclandian.com/images/favicon.ico"],
        share_url: "http://www.micreat.com/#/"
      };
      //跳转地址
      var bbbb =  "https://service.weibo.com/share/share.php?url=" +
          encodeURIComponent(share.share_url) +
          "&title=" +
          share.title +
          "&pic=" +
          share.image_url +
          "&searchPic=true"

        window.open(bbbb, 'newwindow', 'height=1000,width=1000,top=200,left=100');
    },
     tiaozhuan(e){
      if( e == 3){
        this.$router.push({
        path: "/alxq5",
      });
      }else if( e == 2){
      this.$router.push({
        path: "/alxq4",
      });
      }else if( e == 1){
        this.$router.push({
        path: "/alxq2",
      });
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
  },
};
</script>
<style lang="scss">
.alxq2 {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    width: 100%;
    height: 5.17rem;
    background: url("../../../src/assets/images/1501.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
  }
  .alxqboxbox {
    width: 100%;
    background: #fff;
    padding-bottom: 0.8rem;
    .alxqbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 1.1rem;
      .imgbox {
        width: 10rem;
        height: 5rem;
        background: #0f0;
        margin: 0 auto;
        margin-bottom: 0.4rem;
        background: url('../../assets/images/1625137306(1).jpg') no-repeat center;
      }
      .text {
        display: flex;
        justify-content: left;
        align-items: center;
      }
      .text1 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #626262;
        margin-bottom: 0.2rem;
      }
      .text2 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        margin-bottom: 0.9rem;
      }
      .text3 {
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        line-height: 0.4rem;
        margin-bottom: 0.87rem;
      }
      .gjcanwxwbqqbox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.4rem;
        .gjcanwxwbqqleft {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2d60fe;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .gjcanwxwbqqright {
          display: flex;
          justify-content: center;
          align-items: center;
          .gjcanwxwbqqrightimg {
            width: 0.3rem;
            height: 0.3rem;
            background-size: 100% 100%;
            margin-left: 0.5rem;
          }
          .gjcanwxwbqqrightimg1 {
            background: url("../../assets/images/qqt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg2 {
            background: url("../../assets/images/wxt.png") no-repeat center;
          }
          .gjcanwxwbqqrightimg3 {
            background: url("../../assets/images/wbt.png") no-repeat center;
          }
        }
      }
      .hengxian {
        width: 100%;
        height: 0.01rem;
        background: #efefef;
        margin-bottom: 0.8rem;
      }
      .xgaltext {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #2a2e2e;
        margin-bottom: 0.5rem;
      }
      .xgalbox {
        display: flex;
        flex-wrap: wrap;
        .xgalboxs {
          width: 3.86rem;
          height: 2.89rem;
          background-size: 100% 100%;
          margin-right: 0.2rem;
          position: relative;
          .xgalboxstext {
            width: 387px;
            height: 52px;
            background: rgba($color: #010206, $alpha: 0.3);
            position: absolute;
            bottom: 0;
            display: flex;
            justify-content: left;
            align-items: center;
            padding-left: 0.15rem;
            box-sizing: border-box;
            font-size: 0.2rem;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
          }
        }
        .xgalboxs1 {
          background: url("../../assets/images/a3.png") no-repeat center;
        }
        .xgalboxs2 {
          background: url("../../assets/images/a1.png") no-repeat center;
        }
        .xgalboxs3 {
          background: url("../../assets/images/a2.png") no-repeat center;
        }
        .xgalboxs:nth-child(3n) {
          margin-right: 0rem;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/alxq14/index.vue